var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdfWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.75 -0.75 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "convert-PDF-2--essential-files-folder-convert-to-PDF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M41.51785714285714 41.51785714285714c0 0.880842857142857 -0.3500785714285714 1.7258142857142855 -0.9728464285714284 2.3485821428571425s-1.4677392857142857 0.9728464285714284 -2.3485821428571425 0.9728464285714284h-29.89285714285714c-0.8809092857142857 0 -1.7257146428571426 -0.3500785714285714 -2.348615357142857 -0.9728464285714284C5.332088571428571 43.243671428571425 4.982142857142857 42.3987 4.982142857142857 41.51785714285714v-36.535714285714285c0 -0.8809092857142857 0.34994571428571425 -1.7257146428571426 0.9728132142857142 -2.348605392857143C6.577856785714285 2.010650035714286 7.422662142857143 1.6607142857142856 8.303571428571427 1.6607142857142856H29.89285714285714L41.51785714285714 13.285714285714285v28.232142857142854Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1238",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.602076785714285 11.67987c-4.297164642857143 1.27317 13.619650714285712 22.863651428571426 15.530435357142856 17.92305964285714 1.9108842857142858 -4.940525357142857 -23.53398214285714 1.4283471428571426 -19.343335714285715 4.940591785714285 4.190646428571428 3.512078571428571 8.110064999999999 -24.136821428571427 3.8129003571428566 -22.863651428571426Z",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfWhite);
export default __webpack_public_path__ + "static/media/icon-pdf-white.274639a1f4f10f27be863c35928c8636.svg";
export { ForwardRef as ReactComponent };